import './styles/user-details.scss'

import React      from 'react'
import PropTypes  from 'prop-types'
import classnames from 'classnames'

import { Popup, Button, Form } from 'semantic-ui-react'

import Loading from '../components/Loading'

import { getUserFriendlyRoleName } from './utils'

import api from '../redux/api'

const ROLES = [
  { role: 'admin',      description: 'Admin users have full access the UI, are able to perform all types of actions and manage users' },
  { role: 'power_user', description: 'Power Users have full access the UI, are able to perform all types of actions but can not manage users' },
  { role: 'user',       description: 'Users have full access the UI but can not perform any actions or manage users' },
]

const initialState = {
  data:         {},
  loading:      true,
  updating:     false,
  updatedStart: false,
  updatedEnd:   false,
  logs:         [],
  error:        null,
  dirty:        false,
  isNewUser:    false,
}

function RenderError({ error }) {
  return (
    <div className="user-details">
      <div className="ui error message">
        <div className="header">
          Error Loading User Data
        </div>
        <div>
        { error }
        </div>
      </div>
    </div>
  )
}

export default class UserDetails extends React.Component {
  static propTypes = {
    match:   PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
  }

  state = { ...initialState }

  componentDidMount() {
    this.loadUser()
  }

  loadUser = () => {
    const { id } = this.props.match.params

    if (id === 'new') {
      const data = {
        email: '',
        role: 'user',
      }
      this.setState({ isNewUser: true, loading: false, data })
    } else {
      api.loadUser({ id }).then((result) => {
        const data = {
          email: result.email,
          role:  result.role,
        }
        this.setState({ data, loading: false, error: null })
      }).catch((error) => {
        this.setState({ error: error.message, loading: false })
      })
    }
  }

  handleEmailChange = (_, { value }) => {
    this.setState({ data: { ...this.state.data, email: value }, dirty: true })
  }

  handleRoleChange = (_, { value }) => {
    this.setState({ data: { ...this.state.data, role: value }, dirty: true })
  }

  async save() {
    const { data, isNewUser } = this.state
    const { email, role } = data

    if (isNewUser) {
      const result = await api.addUser({ email, role })
      if (result && result.__typename === 'UpdateFailure') {
        throw new Error(result.errorMessage || 'Unable to create user')
      }
    } else {      
      const result = await api.updateUser({ email, role })
      if (result && result.__typename === 'UpdateFailure') {
        throw new Error(result.errorMessage || 'Unable to update user')
      }
    }
  }

  handleSave = () => {
    this.setState({ updating: true }, () => {
      this.save().then(() => {
        this.setState({ dirty: false, updating: false, updatedStart: true }, () => {
          setTimeout(() => {
            this.setState({ updatedStart: false, updatedEnd: true }, () => {
              setTimeout(() => {
                this.setState({ updatedEnd: false })
              }, 2000)
            })
          }, 2000)
        })
      }).catch((error) => {
        this.setState({ dirty: false, updating: false, error: error.message })
      })
    })
  }

  render() {
    const { data, error, loading, dirty, updating, updatedStart, updatedEnd, isNewUser } = this.state
    const { email, role } = data 

    if (loading) return <Loading/>
    if (error)   return <RenderError error={error} />

    const glassPaneClassName    = classnames('glass-pane', { updating })
    const feedbackPaneClassName = classnames('feedback-panel', {
      'updated-start': updatedStart,
      'updated-end':   updatedEnd,
    })

    return (
      <div className="user-details">
        <Form>
          <Form.Field>
            <label>Email</label>

            {  isNewUser && <Form.Input placeholder='User Email' name='email' value={email} onChange={this.handleEmailChange} /> }
            { !isNewUser && <Form.Input placeholder='User Email' name='email' value={email} readOnly /> }
          </Form.Field>

          <Form.Field className="choice">
            <label>Role</label>

            {
              ROLES.map((r) => {
                return <Popup
                  key={r.role}
                  content={r.description}
                  position='right center'
                  trigger={
                    <Form.Radio
                      label={getUserFriendlyRoleName(r.role)}
                      value={r.role}
                      checked={role === r.role}
                      onChange={this.handleRoleChange}
                    />
                } />  
              })
            }
          </Form.Field>
        
          <Button type='submit' disabled={!dirty} primary onClick={this.handleSave}>Submit</Button>
        </Form>

        <div className={glassPaneClassName} />
        <div className={feedbackPaneClassName}>
          User Has Been Successfully Updated
        </div>
      </div>
    )
  }
}